<template>
  <div class="tooltip-wrapper">
    <p class="tooltip-title">
      {{ title }}
    </p>
    <div class="tooltip-content">
      <span v-for="(value, key) in content" :key="key">
        <strong class="key">{{ key }}</strong>
        <p>{{ value }}</p>
      </span>

    </div>
  </div>

</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: false
      },
      content: {
        type: Object,
        required: false
      }
    }
  }
</script>

<style scoped>
.tooltip-wrapper{
  position: relative;
}

.tooltip-title{
  text-decoration: underline;
  font: normal normal normal 14px Poppins;
  letter-spacing: 0.2px;
  color: #6266EA;
  cursor: pointer;
}
.tooltip-title:hover + .tooltip-content{
  display: flex;
  flex-direction: column;
}
.tooltip-content{
  font: normal normal normal 14px Poppins;
  display: none;
  position: absolute;
  z-index: 9;
  background: #fff;
  border-radius: 8px;
  box-shadow:
  0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
  0px 6.7px 5.3px rgba(0, 0, 0, 0.028),
  0px 12.5px 10px rgba(0, 0, 0, 0.035),
  0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
  0px 41.8px 33.4px rgba(0, 0, 0, 0.05),
  0px 100px 80px rgba(0, 0, 0, 0.07);
  padding: 1rem 1.5rem;
}

.tooltip-content span{
  margin: 0.5rem 0;
}

.tooltip-content .key{
  text-transform: capitalize;
}

</style>